import { createFileRoute } from "@tanstack/react-router";
import { InviteCard } from "@/components/InviteCard";

export const Route = createFileRoute("/_authenticated/app/invite")({
  head: () => ({
    meta: [
      { title: "Invite — The Founders App" },
      { property: "og:title", content: "Invite — The Founders App" },
    ],
  }),
  component: InvitePage,
});

function InvitePage() {
  return (
    <div className="mx-auto w-full max-w-3xl">
      <p className="micro-label">Invitations</p>
      <h1 className="etched mt-4 text-3xl font-semibold sm:text-4xl">Bring people you trust.</h1>
      <div className="soft-panel mt-8 p-6">
        <InviteCard />
      </div>
    </div>
  );
}
